import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { inject, Injectable } from '@angular/core';
import { Dtos } from '#models';

@Injectable({
  providedIn: 'root',
})
export class PSSRImportService {
  private http = inject(HttpClient);

  public getApplications(): Observable<Dtos.IdName[]> {
    return this.http.get<Dtos.IdName[]>(`${environment.apiUrl}/pssr/import/applications`);
  }

  public getPSSRInfo(applicationId: number, pssrId: string): Observable<Dtos.ImportResponse> {
    return this.http.get<Dtos.ImportResponse>(`${environment.apiUrl}/pssr/import-info`, {
      params: {
        applicationId,
        pssrId,
      },
    });
  }

  public importPSSR(
    pssrId: string,
    applicationId: number,
    businessUnitId: number,
    organizationId: number,
    areaId: number,
    subAreaId: number
  ) {
    return this.http.post<Dtos.ImportResponse>(`${environment.apiUrl}/pssr/import`, {
      applicationId,
      pssrId: pssrId,
      businessUnitId,
      organizationId,
      areaId,
      subAreaId,
    });
  }

  public importMOCActions(pssrId: number) {
    return this.http.post<Dtos.ImportResponse>(`${environment.apiUrl}/pssr/import-moc-actions`, {
      pssrId: pssrId,
    });
  }
}
